import React, { useEffect, useState } from "react";
import "../../css/why-I-chest.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import FooterPage from "../ExploreMore/footer";

function WhyIchest() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);
  return (
    <>
      <div className={`your-component ${show ? "fade-in-element" : ""}`}>
        <div className="whyichest_base">
          <div className="whyichest_main">
            <div className="whyichest_heading">
              <h1>Why I-Chest</h1>

              <LazyLoadImage
                className="whyichest_heading_logo"
                src="/img/why.webp"
                alt="whyichest"
                effect="blur"
              />
            </div>
            <h4>Legacy Continuity and Digital Security </h4>
            <div className="whyichest_paragraph">
              <p>
                Do you have a contingency plan for unforeseen circumstances—a living transition framework ensuring a seamless handover?
                Are your vital documents safeguarded under the oversight of trusted executors?
                Have you clearly communicated your plans for inheritance, legacy, and beneficiaries with your family, advisors, or legal counsel?
              </p>
            </div>
            <br />

            <div className="whyichest_second_para">
              <div className="whyichest_image">
                <LazyLoadImage
                  className="whyichest_image_img"
                  src="/img/Data-Storage-Security.webp"
                  alt="secure_data_image "
                  effect="blur"
                />
              </div>
              <div className="whyichest_content">
                <p>
                    Imagine a digital sanctuary—a secure, intelligent platform designed not merely for storage but for the thoughtful transmission of your legacy.
                    Within this encrypted repository, your wealth, documents, and directives are protected and precisely delivered to your chosen heirs and stewards.
                </p>
                <br />
                <p>
                    This platform serves as both vault and bridge—connecting your lifetime of achievement to its rightful succession.
                     Trusted attorneys and trustees act as gatekeepers, ensuring your wishes are executed with integrity and precision.
                </p>
                <br/>
                <p>
                    Ultimately, this is more than security—it’s empowerment. It allows you to define, control, and preserve your vision, keeping your most personal affairs confidential until you choose to share them.
                     Your legacy, your plan—organized, protected, and ready for the future.
                </p>
              </div>
            </div>
{/*             <br /> */}
{/*             <div className="whyichest_last_para"> */}

{/*             </div> */}

            
          </div>
        </div>
        <FooterPage/>
      </div>
    </>
  );
}
export default WhyIchest;
